module.exports = __webpack_public_path__ + "static/img/logo_tnp_arrow_only.07ed50f8.svg";